import React from 'react';
import ReactModal from 'react-modal';

/* Components */
import { CloseButton } from './CloseButton';

/* Styles */
import styles from './Modal.module.scss';

ReactModal.setAppElement('#__next');

interface ModalProps {
  open: boolean;
  children: React.ReactNode;
  closeModal: () => void;
}

/* Requires usage of `useModalState.ts` hook to operate modal */
export const Modal = ({ children, open = false, closeModal }: ModalProps) => (
  <ReactModal
    isOpen={open}
    closeTimeoutMS={100}
    shouldCloseOnOverlayClick
    onRequestClose={closeModal}
    className={`${styles.ReactModal__Content}`}
    bodyOpenClassName={`${styles.ReactModal__Body}`}
    overlayClassName={`${styles.ReactModal__Overlay}`}
  >
    {/* Content */}
    {children}

    {/* Close Button */}
    <div className={`${styles.closeButton}`}>
      <CloseButton onClick={closeModal} />
    </div>
  </ReactModal>
);
